export default __webpack_public_path__ + "static/digit-bg-b8fe89711665d80745a7a68369b3832b.png";